export const TMC_TASKS = "TMC_TASKS";
export const TMC_PROJECTS = "TMC_PROJECTS";
export const TMC_SERVERS = "TMC_SERVERS";
export const TMC_SERVER_BY_ID = "TMC_SERVER_BY_ID";
export const TMC_EXECUTIONS_BY_TASK_ID = "TMC_EXECUTIONS_BY_TASK_ID";
export const TMC_LOGS_BY_EXECUTION_ID = "TMC_LOGS_BY_EXECUTION_ID";